var map = {
	"./allopurinol.png": 1052,
	"./atorvastatin.png": 8769,
	"./bactrim_aka_sulfamethoxazole-tmp_ss.png": 4956,
	"./benztropine.png": 3973,
	"./blank.png": 23,
	"./calcium_carbonate_aka_calcium_citrate.png": 4818,
	"./carvedilol.png": 5636,
	"./cellcept.png": 8941,
	"./cellcept_250mg.png": 5265,
	"./cellcept_mycophenolate.png": 438,
	"./cobenfy.png": 4210,
	"./colace.png": 5019,
	"./coreg.png": 6221,
	"./docusate_sodium.png": 833,
	"./docusate_sodium_indrani.png": 5693,
	"./drisdol_vitamin_D_50000_IU_cap.png": 9445,
	"./entresto.png": 4526,
	"./epivir_hbv_aka_lamivudine_100mg.png": 9170,
	"./ezetimibe.png": 6421,
	"./famotidine.png": 938,
	"./farxiga.png": 9498,
	"./ferrous_aka_ferrous_gluconate.png": 672,
	"./fluoxetine.png": 195,
	"./fosamax.png": 8594,
	"./furosemide.png": 774,
	"./icosapent_ethyl.png": 3592,
	"./ingrezza.png": 8774,
	"./keppra.png": 3769,
	"./kerendia.png": 8721,
	"./levemir.png": 3254,
	"./lisinopril.png": 6461,
	"./losartan.png": 3297,
	"./mag_ox.png": 3870,
	"./mepron.png": 9446,
	"./metformin_850mg.png": 1100,
	"./metformin_dad.png": 1286,
	"./norvasc.png": 2586,
	"./nothing.png": 9368,
	"./ozempic.png": 1058,
	"./pantoprazole.png": 678,
	"./pepcid_AC_aka_famotidine.png": 4420,
	"./potassium_chloride.png": 9907,
	"./pravachol_pravastatin_sod.png": 3428,
	"./prednisone.png": 344,
	"./prednisone_deltasone.png": 6375,
	"./prenatal.png": 7561,
	"./prenatal_vitamin.png": 2712,
	"./prevymis_letermovir.png": 4745,
	"./prograf_1mg.png": 6807,
	"./prograf_half_mg_aka_tacrolimus.png": 9047,
	"./rosuvastatin.png": 8381,
	"./senna_time.png": 2025,
	"./silodosin.png": 3442,
	"./tacro_1_mg.png": 724,
	"./telmisartan.png": 1044,
	"./telmisartan_40_mg.png": 3392,
	"./torsemide.png": 91,
	"./uloric.png": 9421,
	"./valcyte_valganciclovir.png": 5822,
	"./vitamin_b12.png": 4986,
	"./vitamin_d3.png": 7945,
	"./voriconazole.png": 4743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7473;